import { FC } from "react";
import { ProjectDeliverablesRowValue } from "../../modelsAndSchemas/models";
import { ProjectCreateClientDeliverable } from "../createDeliverable/ProjectCreateDeliverable";
import { ProjectViewDeliverables } from "../viewDeliverables/ProjectViewDeliverables";

interface ProjectEditDeliverableProps {
  handleCloseModal: () => void;
  pageId: string;
  visible: boolean;
  selectedDeliverables: ProjectDeliverablesRowValue;
  callApiFunction: () => void;
}

export const ProjectEditDeliverable: FC<ProjectEditDeliverableProps> = ({
  visible,
  pageId,
  handleCloseModal,
  selectedDeliverables,
  callApiFunction,
}) => {
  return (
    <>
      {selectedDeliverables?.isProjectFrameworkDeliverable === true ? (
        <ProjectViewDeliverables
          visible={visible}
          onCloseModal={handleCloseModal}
          pageId={pageId}
          callApiFunction={callApiFunction}
          isEditDeliverable={true}
          selectedProjectDeliverableId={selectedDeliverables?.id}
        />
      ) : (
        <ProjectCreateClientDeliverable
          visible={visible}
          handleCloseModal={handleCloseModal}
          pageId={pageId}
          getListOfDeliverablesApi={callApiFunction}
          isEditDeliverable={true}
          deliverableId={selectedDeliverables?.id}
        />
      )}
    </>
  );
};
